// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"284":"f167d62f","453":"1407b060","627":"4e02bf8b","738":"0df12e42","923":"dbf7bf56"}[chunkId] + ".chunk.js";
};